import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { getFormValues, isDirty, isValid, reset } from 'redux-form';
import CreditNoteDetails from './CreditNoteDetails';
import { IApplicationState } from 'ducks/reducers';
import { actions as uiActions } from 'ducks/ui';

const mapStateToProps = (state: IApplicationState) => ({
  dirty: isDirty('CreditNoteDetailsForm')(state),
  values: getFormValues('CreditNoteDetailsForm')(state),
  isValid: isValid('CreditNoteDetailsForm')(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    resetForm: () => reset('CreditNoteDetailsForm'),
    changeConfirmationDialog: uiActions.changeConfirmationDialog,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CreditNoteDetails);
